<template>
  <div>
    <div class="intro-y flex flex-col items-center mt-8 ml-5">
<!--      <h2 class="text-lg font-medium text-blue-700">{{ selected.user.name }}</h2>-->
<!--      <h2 class="font-medium text-blue-400">{{ selected.workshop.name }}</h2>-->
      <button
          type="button"
          class="button border dark:border-dark-5 text-gray-700 dark:text-gray-300 mr-1"
          @click="newRemark"
          v-if="isEditMode"
      >
        New Remark
      </button>
    </div>

    <div class="sm:grid grid-cols-1 gap-4">
      <div class="grid grid-cols-1 gap-6 mt-5">
        <div class="intro-y col-span-12 lg:col-span-6">
          <!-- BEGIN: Form Layout -->
          <div class="intro-y box p-5">
            <div>
              <label>Short Comment</label>
              <input
                  v-model="model.feedback"
                  type="text"
                  class="input w-full border mt-2"
                  placeholder="Input text"
              />
            </div>
            <div class="mt-3">
              <label>The student remained focused on the teacher or the assignment during class?</label>
              <div class="mt-2">
                <TailSelect
                    v-model="model.meta.focus"
                    :options="{
                    hideSelected: false,
                    hideDisabled: false,
                    classNames: 'w-full'
                  }"
                >
                  <option value="Always">Always</option>
                  <option value="Sometimes">Sometimes</option>
                  <option value="Seldom">Seldom</option>
                </TailSelect>
              </div>
            </div>
            <div class="mt-3">
              <label>The student completed class assignments on time, Applying best effort</label>
              <div class="mt-2">
                <TailSelect
                    v-model="model.meta.effort"
                    :options="{
                    hideSelected: false,
                    hideDisabled: false,
                    classNames: 'w-full'
                  }"
                >
                  <option value="Yes">Yes</option>
                  <option value="Needs Improvement">Needs Improvement</option>
                  <option value="No">No</option>
                </TailSelect>
              </div>
            </div>
            <div class="mt-3">
              <label>Grasp on the Topic Subject</label>
              <div class="mt-2">
                <TailSelect
                    v-model="model.meta.topic"
                    :options="{
                    hideSelected: false,
                    hideDisabled: false,
                    classNames: 'w-full'
                  }"
                >
                  <option value="Excellent">Excellent</option>
                  <option value="Good">Good</option>
                  <option value="Satisfactory">Satisfactory</option>
                </TailSelect>
              </div>
            </div>
            <div class="mt-3">
              <label>Overall Performance</label>
              <div class="mt-2">
                <v-rating
                    v-model="model.rating"
                ></v-rating>
              </div>
            </div>
            <div class="text-right mt-5">
              <button type="button" class="button w-24 bg-theme-1 text-white" @click="submit" v-if="!isEditMode">
                Submit
              </button>
              <button type="button" class="button w-24 bg-theme-1 text-white" @click="update(r)" v-else>
                Update
              </button>
            </div>
            <!--            <FilePond></FilePond>-->
          </div>
          <!-- END: Form Layout -->
        </div>
      </div>
    </div>
    <div class="sm:grid grid-cols-1 gap-4 mt-5">
      <div class="grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 grid-cols-1 gap-4 px-4">
        <div class="bg-gray-100 border-gray-300 dark:bg-gray-800 bg-opacity-95 border-opacity-60 | p-4 border-solid rounded-3xl border-2 | flex justify-around cursor-pointer | hover:bg-gray-400 dark:hover:bg-gray-700 hover:border-transparent | transition-colors duration-500" v-for="r in remarks" @click="selectFeedback(r)">
          <v-rating :value="r.rating"></v-rating>
          <div class="flex flex-col justify-center">
            <p class="text-gray-900 dark:text-gray-300 font-semibold">{{ r.feedback }}</p>
            <p class="text-black dark:text-gray-100 text-justify font-semibold">{{ getTime(r.created) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
export default {
  props: ["selected"],
  data() {
    return {
      isEditMode: false,
      model:
          {
            trainer_id:-1,
            wid:-1,
            uid:-1,
            rating:5,
            feedback:"",
            meta: {effort: "", topic: "", focus: ""},
          },
      salesReportFilter: "",
      dashboardInfo : {},
      isTeacher: false,
      remarks: [],
      trainerSubmit: 'https://ucservice.upskill.com.bd/trainer/submit',
      trainerGet: 'https://ucservice.upskill.com.bd/trainer/get/trainer',
      trainerUpdate: 'https://ucservice.upskill.com.bd/trainer/update',
    };
  },
  methods: {
    selectFeedback(r) {
      this.model = r
      this.isEditMode = true
    },
    parseTime() {
      let d = new Date(this.time)
      return d.getTime() / 1000
    },
    getTime(t) {
      return moment(t).format('lll')
    },
    resetModel() {
      this.model = { ...this.selected.model}
      this.model.wid = this.selected.workshop.id
      this.model.uid = this.selected.user.id
      this.model.meta.focus = "Always"
      this.model.meta.effort = "Yes"
      this.model.meta.topic = "Excellent"
      this.model.rating = 5
    },
    newRemark() {
      this.resetModel()
      this.isEditMode = false
    },
    getRemarks() {
      this.$upskill.remarkGet().then(res => {
        this.remarks = res.data.data || []
        this.remarks = this.remarks.filter(o => o.wid == this.selected.workshop.id && o.uid == this.selected.user.id)
      })
    },
    submit() {
      delete this.model['trainer_id']
      this.model['wid'] = parseInt(this.model['wid'])
      this.$upskill.remarkSubmit(this.model).then(res => {
        this.getRemarks()
      })
      // this.model.id = this.remarks.length+1
      // this.remarks.push(this.model)
      this.resetModel()
    },
    update() {
      delete this.model['trainer_id']
      this.model['wid'] = parseInt(this.model['wid'])
      this.$upskill.remarkUpdate(this.model).then(res => {
        this.getRemarks()
      })
      this.resetModel()
    },
    getProfileInfo() {
      this.$upskill.trainerDashboard().then(res => {
        this.dashboardInfo = res.data;
        if (this.dashboardInfo.user.occupation == "upskill-teacher") {
          this.isTeacher = true
        }
      });
    }
  },
  created() {
    this.getProfileInfo()
    this.getRemarks()
    this.model = this.selected.model
    this.model.wid = this.selected.workshop.id
    this.model.uid = this.selected.user.id
    this.model.meta.focus = "Always"
    this.model.meta.effort = "Yes"
    this.model.meta.topic = "Excellent"
    this.model.rating = 5
  }
};
</script>

